module.exports = __webpack_public_path__ + "static/media/signAgreement.7813e88c.svg";